import { connect } from "react-redux";
import { InAppTemplate } from "../../../shared/templates/inapp";

import InAppContent from "../../../views/app/media/InAppContent";
import { appActions } from "../../../redux/actions/in-app";

import "../index.scss";
import { MediaPageProps } from "../../../types/app/mediaTypes";




const MediaManagement = (pageProps: MediaPageProps | any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Media Management"
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  getImageGalleryAction: appActions.GetImageGallery,
  deleteImageAction: appActions.DeleteImage,
  uploadProductImageAction: appActions.UploadProductImage,
  updateProductImageAction: appActions.UpdateProductImage,
  getProductCategoriesAction: appActions.GetStoreCategories,
};

const mapStateToProps = (state: any) => ({
  getImageGalleryRequest: state.allInAppReducers.getImageGalleryReducer,
  deleteImageRequest: state.allInAppReducers.deleteImageReducer,
  uploadProductImageRequest: state.allInAppReducers.uploadProductImageReducer,
  updateProductImageRequest: state.allInAppReducers.updateProductImageReducer,
  getStoreCategoriesRequest: state.allInAppReducers.getStoreCategoriesReducer,
  getProductCategoriesRequest: state.allInAppReducers.getStoreCategoriesReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaManagement);
